import { Alert } from "react-bootstrap";
import styled from "styled-components";

export const StyledAlert = styled(Alert)`
  animation: alertFadeIn 0.4s ease;
  position: fixed;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 90vw;
  z-index: 1060;
  box-shadow: var(--tws-shadow-lg);
  border-radius: var(--tws-radius-pill);
  padding: 0.6rem 1.5rem;
  font-weight: 500;

  @keyframes alertFadeIn {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }
`;
